module.exports = __webpack_public_path__ + "static/about_half-d9deb5faa3b4d76dff63c38b0b026df8.png";